module.exports = __webpack_public_path__ + "img/working-3-1024x768.cecf9a2a.jpg";